module.exports = __webpack_public_path__ + "static/media/NoPicture.ffc1dbfb.svg";